import React,{ useState} from 'react'
import {Navbar,Nav,Container,Button} from 'react-bootstrap'
import { Link } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";
import { ImBlog } from "react-icons/im";
import { HashLink, NavHashLink } from 'react-router-hash-link';
import {
  AiFillStar,
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";
import {FaBlog} from "react-icons/fa"
import "../style.css";
import { CgFileDocument } from "react-icons/cg";
import Certificate from './Certificate';

export default function MyNav() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/">
          <div className="d-flex flex-row justify-content-between">
          <img src="./arman.jpg" className="img-fluid logo" alt="brand" />
          <h5 id='navhead' style={{ marginLeft:'21px',paddingTop:'6px',color:'#fbd9ad'}}>ARMAN SINGH</h5>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav" className="navbarmain">
          <Nav className="ml-auto" defaultActiveKey="#home">
            <Nav.Item>
              <HashLink smooth className='hash' as={Link} to="/#home" onClick={() => updateExpanded(false)}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </HashLink>
            </Nav.Item>

            <Nav.Item>
              <NavHashLink smooth className="hash"
                as={Link}
                to="/#about"
                onClick={() => updateExpanded(false)}
              >
                <FaBlog style={{ marginBottom: "2px" }} />About
              </NavHashLink>
            </Nav.Item>

            <Nav.Item>
             

              <HashLink smooth className='hash'
              
                as={Link}
                to="/#projects"
                onClick={() => updateExpanded(false)}
              >
               
               Projects
              </HashLink>
             
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/resume"
                onClick={() => updateExpanded(false)}
              >
                <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <HashLink smooth className='hash'
                as={Link}
                to="/#skills"
                onClick={() => updateExpanded(false)}
              >
               Skills
              </HashLink>
            </Nav.Item>
            
           

            {/* <Nav.Item className="fork-btn">
              <Button
                href="https://github.com/aramanrajput/"
                target="_blank"
                className="fork-btn-inner"
              >
                <CgGitFork style={{ fontSize: "1.2em" }} />{" "}
                <AiFillStar style={{ fontSize: "1.1em" }} />
              </Button>
            </Nav.Item> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
